export default function CoreCapabilities() {
  const capabilities = [
    {
      icon: 'ri-robot-2-line',
      title: 'Operational Automation',
      description: 'Automate repetitive administrative tasks, internal workflows, and client processes—without sacrificing control or oversight.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Intelligent Assistants',
      description: 'AI agents trained on your internal knowledge, procedures, and policies to support staff, clients, and leadership.'
    },
    {
      icon: 'ri-flow-chart',
      title: 'Workflow Optimization',
      description: 'Refined systems that improve handoffs, approvals, documentation, and task execution across departments.'
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Data & Decision Intelligence',
      description: 'Transform operational data into clear insights that support better planning, forecasting, and performance tracking.'
    }
  ];

  return (
    <section id="capabilities" className="bg-[#F7F9FC] py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center mb-16">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-[0.15em] mb-4 block">Core Capabilities</span>
          <h2 className="text-5xl font-bold text-gray-900" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Comprehensive AI solutions for your business
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {capabilities.map((capability, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-12 hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-20 h-20 flex items-center justify-center rounded-full bg-blue-50 mb-6 group-hover:bg-blue-100 transition-colors">
                <i className={`${capability.icon} text-[#2B6FED] text-4xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{capability.title}</h3>
              <p className="text-base text-gray-600 leading-relaxed mb-6">{capability.description}</p>
              <a href="#contact" className="inline-flex items-center gap-2 text-sm font-semibold text-[#2B6FED] hover:gap-3 transition-all cursor-pointer">
                Learn more
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
